import { SelfServeNode, SelfServeNodes } from "../types";

const findParentPathsFromSelectedNode = (
  tree: SelfServeNodes,
  selectedNode: SelfServeNode
): SelfServeNode[] => {
  const path: SelfServeNode[] = [];
  for (const nodeId in tree) {
    const node = tree[nodeId];
    if (node && node.children && node.children.includes(selectedNode.id)) {
      path.unshift(node);
      const parentPaths = findParentPathsFromSelectedNode(tree, node);
      path.unshift(...parentPaths);
      break;
    }
  }
  return path;
};

export const findPathsFromSelectedNode = (
  tree: SelfServeNodes,
  selectedNode: SelfServeNode
): SelfServeNode[] => {
  const paths = findParentPathsFromSelectedNode(tree, selectedNode);
  paths.push(selectedNode);
  return paths;
};
